<template>
  <div
    class="card pos-rel"
    :class="{ 'pressable': redeemable, 'o-50': disabled, 'pe-n': disabled }"
    @mouseover="hovering = true"
    @mouseleave="hovering = false"
    @click="openRedeemModal"
  >
    <shoutouts-rewards-listing-img :listing="listing" />
    <div class="w-100p h-x14">
      <div class="f-v m-vx1 m-hx2">
        <div class="t bold">
          {{ listing.name }}
        </div>
        <div class="t m-t4 h-min-45 of-h">
          {{ listing.short_description }}
        </div>
        <div class="f-h f-sb f-ac">
          <div class="t gray">
            {{ quantityCopy }}
          </div>
          <div
            v-emoji="`${localizedPointsCost} :${pointsConfig.emoji}:`"
            class="t purple bold"
          />
        </div>
      </div>
    </div>
    <template v-if="hovering">
      <div class="card-overlay shade" />
      <div class="card-overlay content">
        <div class="f-v m-vx2 m-hx2">
          <div class="f h-min-20 h-max-20">
            <div
              v-emoji="`${localizedPointsCost} :${pointsConfig.emoji}:`"
              class="t m-r8"
            />
          </div>
          <div class="h-min-116 h-max-116">
            <div v-slack-format="listing.description || ''" class="t m-b4" />
          </div>
          <div
            class="button inv w-100p m-tx3"
            :class="{ 'c-not-allowed': !redeemable }"
            @click="openRedeemModal"
          >
            {{ redeemable ? 'Redeem' : 'Sold Out' }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';

  const { commit } = useStore();
  const props = defineProps({
    disabled: { type: Boolean, default: false },
    listing: { type: Object, required: true },
    pointsConfig: { type: Object, required: true },
    preview: {
      type: Boolean,
      default: false,
    },
  });
  const hovering = ref(false);

  const redeemable = computed(() => {
    if (props.listing.quantity_available === null || props.listing.quantity_available > 0) {
      return true;
    }
    return false;
  });

  const quantityCopy = computed(() => {
    if (props.listing.quantity_available === null) {
      return 'Available';
    } else if (props.listing.quantity_available > 0) {
      return `${props.listing.quantity_available} Available`;
    }
    return 'Sold Out';
  });

  // TODO: Clean up duplicate method here and in listing.vue.
  const localizedPointsCost = computed(() => {
    if (props.listing.is_gift_card) {
      const options = props.listing.gift_card_options;
      const minPoints = options[0].points;
      const maxPoints = options[options.length - 1].points;
      if (minPoints === maxPoints) return minPoints.toLocaleString();
      return `${minPoints.toLocaleString()} - ${maxPoints.toLocaleString()}`;
    }
    return Number(props.listing.points_cost).toLocaleString() || 0;
  });

  const openRedeemModal = () => {
    if (props.disabled || props.preview || !redeemable.value) {
      return;
    }

    const modalComponent = props.listing.is_gift_card ? 'shoutouts-rewards-modals-redeem-gift-card' : 'shoutouts-rewards-modals-redeem';

    commit('updateModal', {
      visible: true,
      subcomponent: modalComponent,
      data: {
        listing: props.listing,
        pointsConfig: props.pointsConfig,
      },
      size: 'sm',
    });
  };
</script>
